import type { GamePreviewData } from "../api/getGamePreviews";
import { safeJson } from "@/lib/utils/safeJson";

interface GamePreviewsScriptProps {
  previews: Record<number, GamePreviewData>;
}

export function GamePreviewsScript({ previews }: GamePreviewsScriptProps) {
  return (
    <script
      id="__GAME_PREVIEWS__"
      type="application/json"
      dangerouslySetInnerHTML={{ __html: safeJson(previews) }}
    />
  );
}
